// extracted by mini-css-extract-plugin
export default {"button":"FavoriteScreenButton_button__7ZCK4"};